module.exports = __webpack_public_path__ + "static/media/cyber.2aa2cbcb.jpg";